export class Modules {
  id: number;
  program_id: number;
  user_role_id: number;
  module_name: string;
  module_icon: string;
  module_indicate: string;
  created_date: string;
  updated_date: string;
  status: string;
  module_desc: string;
  is_disable_module: string;
  module_name_hi: string;
  module_name_ka: string;
  module_order: string;
  module_name_ma: string;
  module_name_te: string;
  module_name_be: string;
  module_name_ae: string;
  module_name_ta: string;
}

export class UserModulesExists {
  user_id: number;
  user_name: string;
  module_id: number;
  isExist: boolean;
  status: any;
  id: number;
  module_month: number;
  module_year: number;
  statusString : any;
  show: boolean;
}

export class UserModuleModel {
  user_id: number;
  ro_code: number;
  ro_name: number;
  user_detail_name: any;
  user_modules: any[];
  modules:UserModulesExists[];
  status: any;
  id: number;
  module_month: number;
  module_year: number;
}
